import React, { useEffect, useState } from "react";
import styles from "./PrivacyPolicy.module.css";
import { collection, getDoc, getDocs, doc } from "firebase/firestore";
import { db } from "../firebase";
import { fetchAdminContentDoc } from "../utils/adminContent";

function linkifyEmailsInHtml(rawHtml) {
  if (!rawHtml || typeof rawHtml !== "string") return rawHtml || "";
  if (typeof document === "undefined") return rawHtml;

  const emailRegex = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi;
  const container = document.createElement("div");
  container.innerHTML = rawHtml;

  const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
  const textNodes = [];
  while (walker.nextNode()) {
    textNodes.push(walker.currentNode);
  }

  textNodes.forEach((textNode) => {
    const text = textNode.nodeValue || "";
    emailRegex.lastIndex = 0;
    if (!emailRegex.test(text)) return;

    emailRegex.lastIndex = 0;
    const fragment = document.createDocumentFragment();
    let cursor = 0;
    let match = emailRegex.exec(text);

    while (match) {
      const email = match[0];
      const start = match.index;
      if (start > cursor) {
        fragment.appendChild(document.createTextNode(text.slice(cursor, start)));
      }

      const link = document.createElement("a");
      link.href = `mailto:${email}`;
      link.textContent = email;
      fragment.appendChild(link);

      cursor = start + email.length;
      match = emailRegex.exec(text);
    }

    if (cursor < text.length) {
      fragment.appendChild(document.createTextNode(text.slice(cursor)));
    }
    textNode.parentNode?.replaceChild(fragment, textNode);
  });

  return container.innerHTML;
}

const LegalHtmlPage = ({ title, htmlField }) => {
  const [content, setContent] = useState({});

  useEffect(() => {
    async function getWebsiteContent() {
      try {
        const data = await fetchAdminContentDoc(db, {
          getDoc,
          getDocs,
          collection,
          doc,
        });
        if (data) setContent(data);
      } catch (error) {
        console.log("Error: ", error);
      }
    }
    getWebsiteContent();
  }, []);

  const html =
    content[htmlField] ??
    (htmlField === "terms_and_conditions" ? content.terms_conditions : undefined);
  const htmlWithLinks = linkifyEmailsInHtml(html);

  return (
    <div className={`${styles.container} ${styles.documentLtr}`} dir="ltr">
      <h1 className={styles.title}>{title}</h1>
      {htmlWithLinks ? (
        <div
          className={styles.bodyHtml}
          dangerouslySetInnerHTML={{
            __html: htmlWithLinks,
          }}
        />
      ) : (
        <p className={styles.text}>Content is not available yet.</p>
      )}
      {/* <p className={styles.contact}>
        If you have any questions, contact us:
        <br />
        <a href="mailto:infotargetube@gmail.com" className={styles.email}>
          infotargetube@gmail.com
        </a>
      </p> */}
    </div>
  );
};

export default LegalHtmlPage;
